/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useEffect, useState } from "react";
import GetInvolved from "./sections/GetInvolved";
import NewsFeed from "./sections/NewsFeed";
import Banner from "./sections/PageBanner";
import Footer from "./sections/PageFooter";
import PageHeader from "./sections/PageHeader";
import Hero from "./sections/PageHero";
import GlobeMap from "../home/Dashboard/EarthGlobe";
import CookieBanner from "./sections/CookieBanner";
import axios from "../../utils/axios";
import HeroCarousel from "./sections/HeroCarousel";

const WhyItMatters = () => {
    return (
        <section className="bg-white relative">
        <div className="gap-16 items-center py-8 px-4 w-full  lg:grid lg:grid-cols-2 lg:py-16">
            <div>
                <h2 className="mb-4 text-4xl tracking-tight font-bold text-green-600">Why WITS Matters</h2>
                <p className="mb-4 text-lg font-light text-gray-950 lg:text-xl py-5">
                        WITS aims to change the narrative of conservation from one of anecdotal effort to
evidence-based action, measured impact, and collective intelligence. Through this
transformation, conservation becomes not only more accountable and efficient but also more
inclusive and community-driven, laying the groundwork for long-term biodiversity protection.
It recognises that true justice is served not just through arrests—but through convictions,
precedents, and policy reform.
                </p>
    
                <div className="mt-5 space-y-4 sm:space-y-0 sm:space-x-4">
                <a href="#" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
            </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
                <img className="w-full rounded-lg" src={"./why-it-matters.jpg"} alt="Office" />
            </div>
        </div>
    </section>
    )
}

function ConnectingDots(){
    return (
        <section className="bg-gray-900">
    <div className="gap-16 items-center py-8 px-4 mx-auto max-w-(--breakpoint-xl) lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
    <div className="grid grid-cols-1 gap-4 mt-8">
            <img className="w-full" src="./map.svg" alt="map" />
        </div>
        <div className="font-light text-white sm:text-lg">
            <h2 className="mb-4 text-4xl tracking-tight font-bold text-white">Unearthing Hidden Links & Connecting
            the Dots</h2>
            <p className="mb-4 text-white py-5">
            Through data analysis, we
identify seemingly isolated incidents,
reveal patterns and connections between
crimes. This allows investigators to
identify larger trafficking networks and
build stronger cases.
            </p>
            <div className="mt-5 space-y-4 sm:space-y-0 sm:space-x-4">
                <a href="#" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
            </div>
        </div>
    </div>
</section>
    )
}

function Features(){
    return (
        <>
    <section className="bg-gray-950">
  <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-2">
  <h2 className="text-2xl font-bold text-white mb-6 text-center">How We Enable Wildlife Conservation</h2>
        <p className="text-lg text-white mb-12 text-center">
          Our <span className="font-semibold">innovative tools</span> empower the <span className="font-semibold">tracking, prevention, and reporting</span> of wildlife crimes while supporting wildlife conservation efforts. Join us in protecting our planet&apos;s biodiversity.
        </p>
      <div className="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-4 md:space-y-0">
          <div className="border rounded-lg border-gray-700 hover:shadow-xl hover:cursor-pointer p-8">
              <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900">
                  <svg className="w-5 h-5 text-green-400 lg:w-6 lg:h-6 dark:text-primary-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>
              </div>
              <h3 className="text-xl font-light text-white">Case Management</h3>
              <p className="text-white mt-8 mb-8 text-sm font-light">
              Track case progress, manage evidence, and maintain offender databases with secure audit trails.
              </p>

              <a href="/features" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
          </div>
          <div className="border rounded-lg border-gray-700 p-8">
              <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900">
                  <svg className="w-5 h-5 text-green-400 lg:w-6 lg:h-6 dark:text-primary-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"></path></svg>
              </div>
              <h3 className=" text-xl font-light text-white">Analytics and Reporting</h3>
              <p className="text-white mt-8 mb-8 font-light text-sm">
              Generate insights, trends, and customizable reports to inform decisions and drive impactful policies.
              </p>

              <a href="/features" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
          </div>
          <div className="border rounded-lg border-gray-700 p-8">
              <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900">
                <svg className="w-5 h-5 text-green-400 lg:w-6 lg:h-6 dark:text-primary-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"></path></svg>                    
              </div>
              <h3 className="text-xl font-light text-white">Geographical Mapping</h3>
              <p className="text-white mt-8 mb-8 font-light text-sm">
              Visualize crime locations through interactive maps, heatmaps, and layered views for actionable insights.
              </p>

              <a href="/features" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
          </div>

          <div className="border rounded-lg border-gray-700 p-8">
              <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 dark:bg-primary-900">
              <svg className="w-5 h-5 text-green-400 lg:w-6 lg:h-6 dark:text-primary-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd"></path></svg>
              </div>
              <h3 className="text-xl font-light text-white">Incident Reporting</h3>
              <p className="text-white mt-8 mb-10 font-light text-sm">
              Effortlessly report wildlife crimes with detailed fields, media uploads, and real-time updates.
              </p>

              <a href="/features" className="text-green-400 font-light text-sm">Learn more &rarr;</a>
          </div>
      </div>
  </div>
</section>
        </>
    )
}


export default function GuestHome() {
    const [news, setNews] = useState([]);

    useEffect(() => {
        axios.get("/news/all").then(function(res){
            if(res.status === 200){
                console.log(res.data.data);
                setNews(res.data.data)
            }
        }).catch(function(err){
            console.log(err);
        })
    }, []);
    return (
        <>
        <Banner />
        <PageHeader />
        <HeroCarousel
        images={[
            "/images/v1/img12.jpg",
           // "/images/v1/img1.jpg",
            //"/images/v1/img2.jpg",
            "/images/v1/img3.jpg",
            "/images/v1/img4.jpg",
            //"/images/v1/img5.jpg",
            "/images/v1/img6.jpg",
            "/images/v1/img7.jpg",
            "/images/v1/img8.jpg",
            //"/images/v1/img9.jpg",
            "/images/v1/img10.jpg",
            "/images/v1/img11.jpg",
        ]}
        title="Local Action, Global Impact"
        description="Communities driving transparent wildlife conservation through data."
        position="items-center"
        link="/about"
        />
        <Hero />
        <WhyItMatters />
        <GlobeMap />
        <Features />
        <NewsFeed newsItems={news} />
        <ConnectingDots />
        <GetInvolved />
        <Footer />
        <CookieBanner />
        </>
    )
}